import { createFileRoute } from '@tanstack/react-router'
import { Link } from '@tanstack/react-router'
import { buttonVariants } from '@/components/ui/button'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Skeleton } from '@/components/ui/skeleton'
import { trpc } from '@/main'
import { useLingui } from '@lingui/react/macro'

export const Route = createFileRoute('/_app/orgs_/$orgId/users/groups/$groupId/describe/')({
  loader: ({ context, params }) => {
    context.queryClient.prefetchQuery(trpc.orgs.getOrgAndGroups.queryOptions(params.orgId))
  },
  component: RouteComponent,
  pendingComponent: DescribeIntroPending,
})

function DescribeIntroPending() {
  return (
    <section className="flex flex-col items-center gap-6 text-center">
      <div className="flex flex-col items-center gap-1">
        <Skeleton className="h-7 w-14" />
        <Skeleton className="h-6 w-20" />
      </div>
    </section>
  )
}

function RouteComponent() {
  const { orgId, groupId } = Route.useParams()
  const { t } = useLingui()
  const { data: org } = useSuspenseQuery(trpc.orgs.getOrgAndGroups.queryOptions(orgId))

  const group = org?.groups.find((g) => g.id === groupId)

  return (
    <section className="flex flex-col items-center gap-6 text-center">
      <div className="flex flex-col items-center gap-1">
        <h1 className="text-xl font-bold">{org?.name}</h1>
        <h2 className="text-muted-foreground">{group?.name}</h2>
      </div>

      <p className="max-w-3xl leading-loose whitespace-pre-wrap">{t`Anonymous survey on competency preferences.
Follow the instructions we will show you to complete it.
You can complete it in less than five minutes.
Thank you for participating!`}</p>
      <Link
        className={buttonVariants()}
        to="/orgs/$orgId/users/groups/$groupId/describe/$indicator/$step"
        params={{
          orgId,
          groupId,
          indicator:
            group?.basic === true
              ? 'basic'
              : group?.professional === true
                ? 'professional'
                : group?.transversal === true
                  ? 'transversal'
                  : group?.directives === true
                    ? 'directives'
                    : 'finish',
          step:
            group?.basic === true ||
            group?.professional === true ||
            group?.transversal === true ||
            group?.directives === true
              ? 'relevant'
              : 'finish',
        }}
      >
        {t`Next`}
      </Link>
    </section>
  )
}
